module.exports = function ($state, $timeout, categoriesService) {
    return {
        link: function link(scope, elem, attr) {
            const activeClasses = attr.uiSrefActive || attr.uiSrefActiveEq || '';
            const activeEq = !!attr.uiSrefActiveEq;
            const options = scope.$eval(attr.uiSrefOpts);
            let category = scope.$eval(attr.wowCategorySref);

            let stateInfo;

            function updateClasses() {
                if (!category || !activeClasses) {
                    return;
                }

                const isActive = activeEq
                    ? categoriesService.currentCategories.current && categoriesService.currentCategories.current.NodeId === category.NodeId
                    : categoriesService.currentCategories.isActive(category.NodeId);

                elem.toggleClass(activeClasses, isActive);
            }

            elem.on('click', (e) => {
                const button = e.which || e.button;
                if (stateInfo && (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || elem.attr('target')))) {
                    // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
                    const transition = $timeout(() => $state.go(stateInfo.state, stateInfo.params, options));
                    e.preventDefault();
                    e.preventDefault = () => $timeout.cancel(transition);
                }
            });

            scope.$watch(attr.wowCategorySref, (value) => {
                category = value;

                if (!category) {
                    attr.href = undefined;
                    stateInfo = null;
                    return;
                }

                stateInfo = categoriesService.getCategoryStateInfo(category.NodeId);
                elem.attr('href', category ? $state.href(stateInfo.state, stateInfo.params, options) : undefined);

                updateClasses();
            });

            scope.$on('$stateChangeSuccess', () => {
                updateClasses();
            });
        },
    };
};



// WEBPACK FOOTER //
// ./src/shop/categories/category-sref.directive.js